import { createContext } from "react";
import { noop } from "../_util/noop";
export var MenuContext = createContext({
    collapsed: false,
    setMobileCollapsed: noop,
});
export var SubMenuContext = createContext({
    inSubMenu: false,
    onTagChange: noop,
    onSelectedChange: noop,
});
//# sourceMappingURL=MenuContext.js.map